<script setup lang="ts">
import { GpCard } from '@gportal/uikit';
import SshKeysList from './SshKeysList.vue';

withDefaults(defineProps<{ isActive?: boolean }>(), { isActive: false });

const emit = defineEmits<{
  (e: 'keysChange', value: Array<string>);
  (e: 'authTypeSelect'): void;
}>();

const onKeysChange = (keys: Array<string>) => {
  emit('keysChange', keys);
};
</script>

<template>
  <GpCard
    :active="isActive"
    :enlarge-on-hover="false"
    :class="{ 'tw-cursor-pointer': !isActive }"
    @click="emit('authTypeSelect')"
    v-playwright="`nodes-create-login-ssh-keys`"
    :aria-selected="isActive"
  >
    <div class="tw-p-4">
      <p class="tw-mb-2 tw-text-2xl tw-font-bold">SSH public keys</p>
      <p class="tw-mb-2">
        Select one or more SSH public keys that shall be deployed with the installation of each
        node.
      </p>
      <SshKeysList :is-active="isActive" @keys-change="onKeysChange" />
    </div>
  </GpCard>
</template>

<style scoped></style>
